<section  id="templates" class="templates section">
    <div class="container section-title" data-aos="fade-up">
        <h2>Select <span>Invoice</span> Template</h2>
        <p>Choose a professional template to get started with your invoice</p>
    </div>
    
    <div class="container">
        <div class="row">
            <div class="templates-grid">
                @for(template of filteredTemplates; track $index) {
                    <kt-app-template-card [template]="template"
                        (selected)="onTemplateSelect($event)"></kt-app-template-card>
                }
            </div>

            @if(filteredTemplates.length === 0){
                <div class="no-templates">
                    <p>No templates found in this category</p>
                </div>
            }

            <div class="row mt-4 mx-auto">
                <div class="col-md-12 d-flex justify-content-center">
                    <a href="#" (click)="onSkip(); $event.preventDefault()" class="btn-get-started me-2">
                        <span>Skip</span><i class="bi bi-arrow-right"></i>
                    </a>
                    <a routerLink="/pricing" class="btn-get-started"><span>Want customization?</span><i
                            class="bi bi-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>